import React from 'react';
import ProfileAvatar from '../common/ProfileAvatar';

export interface HubParticipantPillProps {
  id: string;
  first_name: string;
  avatar_url?: string | null;
  /** Display label (e.g. "Recruteur"). Defaults to first_name */
  label?: string;
  isActive: boolean;
  onClick: () => void;
  unreadCount?: number;
}

export const HubParticipantPill: React.FC<HubParticipantPillProps> = ({
  id,
  first_name,
  avatar_url,
  label,
  isActive,
  onClick,
  unreadCount = 0,
}) => {
  const displayLabel = label ?? first_name;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-2 rounded-full transition-colors relative ${
        isActive
          ? 'bg-primary pr-4 text-white'
          : 'bg-transparent px-0 py-0 text-secondary hover:text-primary'
      }`}
    >
      <ProfileAvatar
        profile_id={id}
        first_name={first_name}
        avatar_url={avatar_url}
        className={`h-9 w-9 ${isActive ? 'border-2 border-primary' : 'border border-transparent'}`}
      />
      <span className={`font-semibold ${isActive ? 'text-white' : ''}`}>{displayLabel}</span>
      {unreadCount > 0 && (
        <div className="absolute left-6 -top-2 flex h-5 w-5 min-w-[1.25rem] items-center justify-center rounded-full bg-[#FFB00E] text-xs font-bold text-black">
          {unreadCount > 99 ? '99+' : unreadCount}
        </div>
      )}
    </button>
  );
};
